import authService from "../Services/Auth.service";
import Helper from "../helpers/helper.service";
import userService from "../helpers/user.service";
import eventBus, { DARK_MODE_CHANGE_EVENT } from "../helpers/event.bus";
import { getSsoLogoutUrl, loadSsoConfig } from "../helpers/sso.service";

const MenuLogin = {
  methods: {
    async logout() {
      let ssoLogoutUrl = null
      try {
        swalLoading.fire('', 'Realizando logout, aguarde...')
        await loadSsoConfig(true)
        ssoLogoutUrl = getSsoLogoutUrl(`${window.location.origin}/login`)
        await authService.Logout()
      } catch (e) {
        Helper.messageExceptionHandler(e)
      } finally {
        userService.destroyUser()
        swalLoading.close()
        if (ssoLogoutUrl) {
          window.location.href = ssoLogoutUrl
          return
        }
        await this.$router.replace('/login')
      }
    },
    syncDarkModeState() {
      if (window.getDarkMode) {
        this.darkModeEnabled = window.getDarkMode()
      } else {
        this.darkModeEnabled = localStorage.getItem('darkModeEnabled') === 'true'
      }
    },
    onDarkModeChange(event) {
      this.darkModeEnabled = !!event.detail?.enabled
    },
    toggleDarkMode() {
      const enabled = !(window.getDarkMode?.() ?? this.darkModeEnabled)
      if (window.setDarkMode) {
        window.setDarkMode(enabled)
      } else {
        localStorage.setItem('darkModeEnabled', String(enabled))
        document.body.classList.toggle('dark-mode', enabled)
        eventBus.dispatchEvent(new CustomEvent(DARK_MODE_CHANGE_EVENT, { detail: { enabled } }))
      }
    },
  },
  mounted() {
    this.syncDarkModeState()
    eventBus.addEventListener(DARK_MODE_CHANGE_EVENT, this.onDarkModeChange)
  },
  beforeUnmount() {
    eventBus.removeEventListener(DARK_MODE_CHANGE_EVENT, this.onDarkModeChange)
  },
}

export default MenuLogin
